export const formatBoolean = (value: boolean): string => {
  if (value === false) {
    return 'No';
  }
  return 'Yes';
};
